export const DISABLE_PERSONAL_INFO_STEP = true;

// Helper function to check if personal info step is disabled
export function isPersonalInfoStepDisabled(): boolean {
  // You can modify this logic to read from environment variables,
  // localStorage, or any other configuration source
  return DISABLE_PERSONAL_INFO_STEP;
}

// For development/testing, you can override via localStorage
export function isPersonalInfoStepDisabledWithOverride(): boolean {
  if (typeof window !== 'undefined') {
    const override = localStorage.getItem('DISABLE_PERSONAL_INFO_STEP');
    if (override !== null) {
      return override === 'true';
    }
  }
  return isPersonalInfoStepDisabled();
}
